<script setup lang="ts">
import { computed, watchEffect } from 'vue';
import { useRoute } from 'vue-router';

import AppHeader from '@/components/layout/AppHeader.vue';
import CookiesConsent from '@/components/CookiesConsent.vue';
import { DEFAULT_LOCALE, LOCALE_META } from '@/i18n/locales';

const route = useRoute();

const locale = computed(() => route.meta.locale ?? DEFAULT_LOCALE);

/**
 * master.blade.php loaded one Google Fonts family per locale — Titillium Web
 * for Estonian, Alegreya Sans otherwise. The stylesheet is swapped rather than
 * loading both, so the Russian pages don't pay for the Estonian font.
 */
watchEffect(() => {
  const family = LOCALE_META[locale.value].fontFamily.replace(/ /g, '+');
  const href = `https://fonts.googleapis.com/css?family=${family}:200,300,400,600,700&display=swap`;
  const id = 'locale-font';

  let link = document.getElementById(id) as HTMLLinkElement | null;
  if (!link) {
    link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }
  if (link.href !== href) {
    link.href = href;
  }
});
</script>

<template>
  <AppHeader />

  <RouterView v-slot="{ Component }">
    <!-- Keyed on the full path so switching locale remounts the page and its
         copy is re-read, rather than patching Russian text into Estonian DOM. -->
    <component :is="Component" :key="route.fullPath" />
  </RouterView>

  <CookiesConsent />

  <div class="stripes"></div>
</template>
